// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconRmsClassroomManager_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M.000020111 8V2H24V8H22V4L2.00002 4V8H.000020111ZM15 12C15 13.6569 13.6569 15 12 15 10.3432 15 9.00002 13.6569 9.00002 12 9.00002 10.3431 10.3432 9 12 9 13.6569 9 15 10.3431 15 12ZM12.0001 17C14.2597 17 16.2275 18.2491 17.2509 20.0944 17.9676 19.416 18.9352 19 20 19 21.8638 19 23.4299 20.2748 23.874 22H0C.444043 20.2748 2.01014 19 3.87398 19 4.98015 19 5.98145 19.449 6.70556 20.1747 7.71585 18.2854 9.70785 17 12.0001 17ZM6.00002 15C6.00002 16.1046 5.10459 17 4.00002 17 2.89545 17 2.00002 16.1046 2.00002 15 2.00002 13.8954 2.89545 13 4.00002 13 5.10459 13 6.00002 13.8954 6.00002 15ZM20 17C21.1046 17 22 16.1046 22 15 22 13.8954 21.1046 13 20 13 18.8955 13 18 13.8954 18 15 18 16.1046 18.8955 17 20 17Z" class="svg-bg"/>
</svg>
`;
/**
 * IconRmsClassroomManager is a generated icon component.
 */
let IconRmsClassroomManager = IconRmsClassroomManager_1 = class IconRmsClassroomManager extends IconBaseElement {
    render() {
        return html `${IconRmsClassroomManager_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconRmsClassroomManager.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconRmsClassroomManager = IconRmsClassroomManager_1 = __decorate([
    customElement('zui-icon-rms-classroom-manager')
], IconRmsClassroomManager);
export { IconRmsClassroomManager };
